import React from 'react';

const FooterUspItem = ({ item }) => {
  return (
    <div className="footer-usps__usp">
      <img alt="" src={item.footerUspIcon} />
      <div className="[ footer-usps__usp-title ] [ header-6 ]">
        {item.footerUspTitle}
      </div>
      <div className="[ footer-usps__usp-text ] [ text-medium lh-2 ] ">
        {item.footerUspText}
      </div>
    </div>
  );
};

export default FooterUspItem;
